import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const ProductLandingPage = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14913)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FFEDBF"
          />
          <path
            d="M175.954 47.8522V120.831C175.954 123.251 174.993 125.571 173.282 127.282C171.571 128.993 169.251 129.954 166.831 129.954H80.1686C77.7492 129.954 75.4289 128.993 73.7181 127.282C72.0073 125.571 71.0462 123.251 71.0462 120.831V47.8522H175.954Z"
            fill="#66E1FF"
          />
          <path
            d="M71.0462 47.8522V120.831C71.0462 123.251 72.0073 125.571 73.7181 127.282C75.4289 128.993 77.7492 129.954 80.1686 129.954H84.7298L166.831 47.8522H71.0462Z"
            fill="#C2F3FF"
          />
          <path
            d="M175.954 47.8523H71.0462V34.1687C71.0462 31.7493 72.0073 29.4289 73.7181 27.7182C75.4289 26.0074 77.7492 25.0463 80.1686 25.0463H166.831C169.251 25.0463 171.571 26.0074 173.282 27.7182C174.993 29.4289 175.954 31.7493 175.954 34.1687V47.8523Z"
            fill="white"
          />
          <path
            d="M166.831 25.0463H80.1686C77.7492 25.0463 75.4289 26.0074 73.7181 27.7182C72.0073 29.4289 71.0462 31.7493 71.0462 34.1687V120.831C71.0462 123.251 72.0073 125.571 73.7181 127.282C75.4289 128.993 77.7492 129.954 80.1686 129.954H166.831C169.251 129.954 171.571 128.993 173.282 127.282C174.993 125.571 175.954 123.251 175.954 120.831V34.1687C175.954 31.7493 174.993 29.4289 173.282 27.7182C171.571 26.0074 169.251 25.0463 166.831 25.0463Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.0462 47.8522H175.954"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.0104 37.5896C86.708 37.5896 86.418 37.4694 86.2041 37.2556C85.9903 37.0417 85.8701 36.7517 85.8701 36.4493C85.8701 36.1468 85.9903 35.8568 86.2041 35.6429C86.418 35.4291 86.708 35.309 87.0104 35.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M87.0104 37.5896C87.3128 37.5896 87.6029 37.4694 87.8167 37.2556C88.0306 37.0417 88.1507 36.7517 88.1507 36.4493C88.1507 36.1468 88.0306 35.8568 87.8167 35.6429C87.6029 35.4291 87.3128 35.309 87.0104 35.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M159.99 56.8275H87.0104C86.4056 56.8275 85.8255 57.0678 85.3978 57.4955C84.9701 57.9232 84.7298 58.5033 84.7298 59.1081V68.2305C84.7298 68.8354 84.9701 69.4154 85.3978 69.8431C85.8255 70.2708 86.4056 70.5111 87.0104 70.5111H159.99C160.594 70.5111 161.175 70.2708 161.602 69.8431C162.03 69.4154 162.27 68.8354 162.27 68.2305V59.1081C162.27 58.5033 162.03 57.9232 161.602 57.4955C161.175 57.0678 160.594 56.8275 159.99 56.8275Z"
            fill="#FFEF5E"
          />
          <path
            d="M87.0104 56.8275C86.4056 56.8275 85.8255 57.0678 85.3978 57.4955C84.9701 57.9232 84.7298 58.5033 84.7298 59.1081V68.2305C84.7298 68.8354 84.9701 69.4154 85.3978 69.8431C85.8255 70.2708 86.4056 70.5111 87.0104 70.5111H139.464L153.148 56.8275H87.0104Z"
            fill="#FFF9BF"
          />
          <path
            d="M159.99 56.8275H87.0104C86.4056 56.8275 85.8255 57.0678 85.3978 57.4955C84.9701 57.9232 84.7298 58.5033 84.7298 59.1081V68.2305C84.7298 68.8354 84.9701 69.4154 85.3978 69.8431C85.8255 70.2708 86.4056 70.5111 87.0104 70.5111H159.99C160.594 70.5111 161.175 70.2708 161.602 69.8431C162.03 69.4154 162.27 68.8354 162.27 68.2305V59.1081C162.27 58.5033 162.03 57.9232 161.602 57.4955C161.175 57.0678 160.594 56.8275 159.99 56.8275Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.961 80.208H87.4814C87.0444 80.208 86.6252 80.3816 86.3162 80.6907C86.0071 80.9997 85.8335 81.4189 85.8335 81.8559V95.0393C85.8335 95.4763 86.0071 95.8955 86.3162 96.2045C86.6252 96.5136 87.0444 96.6872 87.4814 96.6872H103.961C104.398 96.6872 104.817 96.5136 105.126 96.2045C105.435 95.8955 105.608 95.4763 105.608 95.0393V81.8559C105.608 81.4189 105.435 80.9997 105.126 80.6907C104.817 80.3816 104.398 80.208 103.961 80.208Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.3613 80.6456L105.082 96.2481"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.3613 96.2481L105.082 80.6456"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.961 103.75H87.4814C87.0444 103.75 86.6252 103.924 86.3162 104.233C86.0071 104.542 85.8335 104.961 85.8335 105.398V118.581C85.8335 119.018 86.0071 119.437 86.3162 119.747C86.6252 120.056 87.0444 120.229 87.4814 120.229H103.961C104.398 120.229 104.817 120.056 105.126 119.747C105.435 119.437 105.608 119.018 105.608 118.581V105.398C105.608 104.961 105.435 104.542 105.126 104.233C104.817 103.924 104.398 103.75 103.961 103.75Z"
            fill="#FFEF5E"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.3613 104.188L105.082 119.79"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.3613 119.79L105.082 104.188"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M116.805 82.5625H162.417"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M116.805 91.6846H153"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M116.805 100.808H157.635"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M116.805 109.562H148.734"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M116.805 117.875H136.963"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M100.694 37.5896C100.392 37.5896 100.102 37.4694 99.8877 37.2556C99.6739 37.0417 99.5537 36.7517 99.5537 36.4493C99.5537 36.1468 99.6739 35.8568 99.8877 35.6429C100.102 35.4291 100.392 35.309 100.694 35.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M100.694 37.5896C100.996 37.5896 101.286 37.4694 101.5 37.2556C101.714 37.0417 101.834 36.7517 101.834 36.4493C101.834 36.1468 101.714 35.8568 101.5 35.6429C101.286 35.4291 100.996 35.309 100.694 35.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M114.378 37.5896C114.075 37.5896 113.785 37.4694 113.571 37.2556C113.357 37.0417 113.237 36.7517 113.237 36.4493C113.237 36.1468 113.357 35.8568 113.571 35.6429C113.785 35.4291 114.075 35.309 114.378 35.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M114.378 37.5896C114.68 37.5896 114.97 37.4694 115.184 37.2556C115.398 37.0417 115.518 36.7517 115.518 36.4493C115.518 36.1468 115.398 35.8568 115.184 35.6429C114.97 35.4291 114.68 35.309 114.378 35.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M209.437 34.2158L205.423 30.0237L205.572 29.3927L206.772 24.4063C206.831 24.1343 206.783 23.8504 206.639 23.6115C206.496 23.3726 206.266 23.1963 205.996 23.1178L200.405 21.4697L198.739 15.9361C198.677 15.7346 198.559 15.5547 198.398 15.4175C198.237 15.2802 198.039 15.1915 197.829 15.1617C197.686 15.1382 197.539 15.1435 197.398 15.1771L191.731 16.501L187.494 12.5295C187.283 12.3374 187.007 12.2307 186.721 12.2307C186.434 12.2307 186.158 12.3374 185.948 12.5295L181.71 16.501L176.046 15.1683C175.771 15.1101 175.485 15.1564 175.243 15.2979C175.002 15.4394 174.823 15.6657 174.743 15.9317L173.073 21.4675L167.479 23.1134C167.203 23.1938 166.97 23.3763 166.827 23.6229C166.684 23.8696 166.643 24.1613 166.712 24.4372L168.05 30.0524L164.843 33.3906L164.794 33.4392L164.035 34.2357C163.84 34.4404 163.732 34.7111 163.732 34.9925C163.732 35.2738 163.84 35.5445 164.035 35.7492L164.64 36.3825L165.532 37.3158L165.597 37.3797L168.05 39.9413L166.712 45.5565C166.643 45.8322 166.683 46.1236 166.826 46.3702C166.968 46.6168 167.202 46.7995 167.477 46.8803L173.07 48.5285L174.736 54.062C174.818 54.3319 175 54.5609 175.246 54.702C175.493 54.8431 175.784 54.8857 176.061 54.821L181.739 53.4972L185.085 56.6302L185.172 56.7185L185.977 57.4687C186.184 57.6617 186.458 57.7692 186.742 57.7692C187.026 57.7692 187.3 57.6617 187.507 57.4687L189.862 55.2623L191.744 53.4972L197.421 54.821C197.699 54.8895 197.994 54.8488 198.244 54.7073C198.493 54.5659 198.678 54.3348 198.759 54.062L200.425 48.5307L206.018 46.8825C206.294 46.8022 206.528 46.6197 206.671 46.373C206.814 46.1264 206.855 45.8347 206.785 45.5587L205.907 41.9006L205.438 39.9413L209.453 35.7492C209.648 35.5422 209.756 35.2698 209.756 34.9869C209.756 34.7041 209.648 34.4317 209.453 34.2247L209.437 34.2158Z"
            fill="#FFEF5E"
          />
          <path
            d="M165.533 37.3226L164.036 35.7536C163.84 35.5488 163.732 35.278 163.732 34.9966C163.732 34.7152 163.84 34.4445 164.036 34.2397L168.052 30.0468L166.713 24.4282C166.648 24.1541 166.691 23.8656 166.833 23.6219C166.976 23.3782 167.208 23.1977 167.481 23.1174L173.077 21.4689L174.743 15.9342C174.823 15.6668 175.002 15.4392 175.245 15.2971C175.487 15.155 175.775 15.1091 176.051 15.1684L181.729 16.5035L185.969 12.5313C186.176 12.3382 186.449 12.2307 186.734 12.2307C187.018 12.2307 187.292 12.3382 187.499 12.5313L191.739 16.5035L197.419 15.1795C197.696 15.1148 197.988 15.1574 198.234 15.2986C198.481 15.4397 198.663 15.6687 198.745 15.9386L200.411 21.4733L206.007 23.1218C206.283 23.2021 206.517 23.3847 206.66 23.6314C206.803 23.8781 206.844 24.1699 206.775 24.4459L205.436 30.0401L209.452 34.2331C209.647 34.4378 209.756 34.7086 209.756 34.99C209.756 35.2714 209.647 35.5422 209.452 35.747L205.436 39.9399L206.786 45.5562C206.855 45.8322 206.814 46.124 206.671 46.3707C206.528 46.6174 206.294 46.8 206.018 46.8803L200.422 48.5288L198.756 54.0635C198.674 54.3359 198.489 54.5666 198.24 54.7076C197.99 54.8486 197.696 54.889 197.417 54.8204L191.739 53.4963L187.499 57.4686C187.292 57.6617 187.018 57.7692 186.734 57.7692C186.449 57.7692 186.176 57.6617 185.969 57.4686L185.163 56.7161"
            stroke="#1E1E1E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M164.768 51.5387L168.73 55.1511"
            stroke="#1E1E1E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M175.992 28.4385L191.05 42.1634"
            stroke="#1E1E1E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M190.259 41.4408L167.938 54.4287L165.561 52.2611L176.783 29.1614L190.258 41.439L190.259 41.4408Z"
            fill="#FF5A4F"
          />
          <path
            d="M190.259 41.4408L167.938 54.4287L165.561 52.2611L176.783 29.1614L190.258 41.439L190.259 41.4408Z"
            stroke="#1E1E1E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M179.552 47.6688C179.974 47.9624 180.33 48.3383 180.599 48.7734C180.868 49.2085 181.044 49.6935 181.116 50.1985C181.188 50.7035 181.155 51.2178 181.019 51.7096C180.882 52.2013 180.645 52.6602 180.323 53.0577C180 53.4553 179.599 53.7831 179.143 54.021C178.688 54.2589 178.188 54.4018 177.674 54.4409C177.161 54.48 176.645 54.4144 176.157 54.2482C175.67 54.082 175.223 53.8187 174.843 53.4746L172.773 51.5886"
            stroke="#1E1E1E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M185 30.8196L188.655 24.2938"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M188.03 33.1287L192.494 32"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14913">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
ProductLandingPage.displayName = 'ProductLandingPage';
